import { Badge } from '@/components/ui/badge';
import {
  MEMBER_STATUS_META,
  INVITATION_STATUS_META,
  type MemberStatus,
} from '@/pages/team/teamLogic';

/** Чип статуса участника: Активен (зелёный) / Заблокирован (amber). */
export function MemberStatusBadge({ status }: { status: MemberStatus }) {
  const meta = MEMBER_STATUS_META[status];
  return <Badge variant={meta.badgeVariant}>{meta.label}</Badge>;
}

/** Чип статуса приглашения: Приглашён / Истекло. */
export function InvitationStatusBadge({ expired }: { expired: boolean }) {
  const meta = expired
    ? INVITATION_STATUS_META.expired
    : INVITATION_STATUS_META.invited;
  return (
    <Badge variant={meta.badgeVariant} className="border-dashed">
      {meta.label}
    </Badge>
  );
}
